import React, { createContext, useContext, useState } from 'react';

export type FullScreenScanPartNotesParams = {
  scanId?: string;
  scanPartId?: string;
};

type FullScreenScanPartNotesContextType = FullScreenScanPartNotesParams & {
  showNotes: (scanId: string, scanPartId: string) => void;
  closeNotes: () => void;
};

const FullScreenScanPartNotesContext = createContext<FullScreenScanPartNotesContextType | null>(null);

export const useFullScreenScanPartNotes = () => {
  const context = useContext(FullScreenScanPartNotesContext);
  if (!context) throw new Error('useFullScreenScanPartNotes must be used within a FullScreenScanPartNotesProvider');
  return context;
};

export const FullScreenScanPartNotesProvider = ({ children }: { children: React.ReactNode }) => {
  const [params, setParams] = useState<FullScreenScanPartNotesParams | null>(null);
  return (
    <FullScreenScanPartNotesContext.Provider
      value={{
        ...params,
        showNotes: (scanId: string, scanPartId: string) => {
          setParams({ scanId, scanPartId });
        },
        closeNotes: () => setParams(null),
      }}
    >
      {children}
    </FullScreenScanPartNotesContext.Provider>
  );
};
